class DocumentationSockets {
    constructor() {
        this.canCloseFolder = false;
        this.callbackReadingFunc = false;
    }

    disablePreviousListeners() {
        docSocket.off(SocketEvents.SET_LIKE_RESPONSE());
        docSocket.off(SocketEvents.SET_LIKE_COMMENT_RESPONSE());
        docSocket.off(SocketEvents.SET_FAVORITE_RESPONSE());
        docSocket.off(SocketEvents.RATE_DOCUMENT_RESPONSE());
        docSocket.off(SocketEvents.REMOVE_NEW_RESPONSE());
        docSocket.off(SocketEvents.ADD_COMMENT_RESPONSE());
        docSocket.off(SocketEvents.EDIT_COMMENT_RESPONSE());
        docSocket.off(SocketEvents.REMOVE_COMMENT_RESPONSE());
    }

    startNodeConnection() {
        // console.trace('startNodeConnection');

        if (!docSocket) {
            docSocket = api.quizSoquet();
        }

        // Desenganchar todos los eventos de respuesta de node de la documentacion al cargar un mundo
        this.disablePreviousListeners();

        let that = this;

        docSocket.on(SocketEvents.SET_LIKE_RESPONSE(), function (data) {

            if (data['success']) {

                let likeIcon = $("#like-icon-" + data['document_id']);

                const documentId = data['document_id'];
                const document = documentationScreenController.getDocument(documentId);
                let folder = documentationScreenController.getCurrentFolder();
                let folderId = folder ? folder.id : null;
                let documentOpenedInChat = chatScreenController.projectDocumentDetailsOpen;

                if (documentOpenedInChat && !folder) {
                    folder = chatScreenController.sendedProjectDocuments[documentId].folder;
                    folderId = folder.id;
                }

                // Identificadores del gif de like
                const listLikeAnimation = $("#gif-document-liked-" + documentId + "-standar");
                const wallLikeAnimation = $("#gif-document-liked-" + documentId + "-advanced-" + folderId).last();
                const detailsLikeAnimation = $("#gif-document-liked-" + documentId + "-details");
                const pathLikeAnimation = $("#gif-document-liked-" + documentId + "-details-path");
                const pathScrollLikeAnimation = $("#gif-document-liked-" + documentId + "-scroll-path");

                // Botones de like
                const listLikeButton = $(".slide-action-button[data-document=" + documentId + "][data-action=like]");
                const wallLikeButton = $(".mark-liked-advanced[data-document=" + documentId + "]").last();
                const detailsLikeButton = $(".mark-liked[data-document=" + documentId + "]");
                const pathActionButton = $(".path-action-button[data-action=like]");
                const pathScrollActionButton = $(".scroll-action-button[data-action=like]");

                const socialDataLikeIcon = $(".social-data-like-icon-container.is-like[data-document=" + documentId + "]");
                const socialDataNotLikeIcon = $(".social-data-like-icon-container.is-not-like[data-document=" + documentId + "]");
                const likeIconContainer = $(".like-icon-container.is-like[data-document=" + documentId + "]");
                const notLikeIconContainer = $(".like-icon-container.is-not-like[data-document=" + documentId + "]");

                const wallLikes = $(".bf-smart-list[data-document=" + documentId + "] .document-likes-value");
                const detailsLikes = $("#document-details-content .document-likes-value");
                const currentLikesNumber = parseInt(wallLikes.last().length > 0 ? wallLikes.last().text() : detailsLikes.text());

                if (window.reactZustandBridge) {
                    window.reactZustandBridge.updateContent(
                        document.folder.id,
                        document.id,
                        {
                            isLiked: data['like'] ?? false,
                            metrics: {
                                likes: data['like'] ? document.total_likes++ : document.total_likes--,
                            }
                        }
                    );
                }

                if (data['like']) {

                    document.like = true;
                    document.total_likes += 1;
                    likeIcon.show();

                    // console.trace('like...', document);


                    // Like desde la vista detalles
                    if (documentationScreenController.folderModeView === 'details') {

                        notLikeIconContainer.hide();
                        DocumentationUtils.likeAnimation(detailsLikeAnimation, function () {
                            likeIconContainer.show();
                            socialDataNotLikeIcon.hide();
                            socialDataLikeIcon.show();
                            detailsLikeAnimation.html(null);
                            detailsLikes.text(isNaN(currentLikesNumber) ? 1 : currentLikesNumber + 1);
                            wallLikes.text(isNaN(currentLikesNumber) ? 1 : currentLikesNumber + 1);

                        });

                        if (pathActionButton.length > 0) {

                            notLikeIconContainer.hide();
                            DocumentationUtils.likeAnimation(pathLikeAnimation, function () {

                                likeIconContainer.show();
                                pathLikeAnimation.html(null);

                            });

                        }

                        if (pathScrollActionButton.length > 0) {

                            notLikeIconContainer.hide();
                            DocumentationUtils.likeAnimation(pathScrollLikeAnimation, function () {

                                likeIconContainer.show();
                                pathScrollLikeAnimation.html(null);

                            });

                        }

                        // Like desde la vista muro
                    } else if (documentationScreenController.folderModeView === 'advanced') {

                        notLikeIconContainer.hide();
                        DocumentationUtils.likeAnimation(wallLikeAnimation, function () {

                            likeIconContainer.show();
                            socialDataNotLikeIcon.hide();
                            socialDataLikeIcon.show();
                            wallLikeAnimation.html(null);
                            wallLikes.text(isNaN(currentLikesNumber) ? 1 : currentLikesNumber + 1);

                        });

                        // Like desde la vista lista
                    } else {

                        notLikeIconContainer.hide();
                        DocumentationUtils.likeAnimation(listLikeAnimation, function () {

                            likeIconContainer.show();
                            socialDataNotLikeIcon.hide();
                            socialDataLikeIcon.show();
                            listLikeAnimation.html(null)

                        });

                    }

                } else {


                    document.like = false;
                    document.total_likes -= 1;
                    likeIcon.hide();

                    // console.trace('likeAnimation', document);


                    likeIconContainer.hide();
                    notLikeIconContainer.show();
                    socialDataLikeIcon.hide();
                    socialDataNotLikeIcon.show();
                    pathActionButton.find(".is-like").hide();
                    pathActionButton.find(".is-not-like").show();
                    detailsLikes.text(currentLikesNumber === 1 ? "--" : currentLikesNumber - 1);
                    wallLikes.text(currentLikesNumber === 1 ? "--" : currentLikesNumber - 1);

                }

            } else {
                // console.log(Translator.trans('TR_SET_LIKE_ERROR'));
                // console.log(data['message']);
            }
        });

        docSocket.on(SocketEvents.SET_LIKE_COMMENT_RESPONSE(), function (data) {

            if (data['success']) {

                const documentId = data['document_id'];
                const commentId = data['comment_id'];
                const document = documentationScreenController.getDocument(documentId);
                let folder = documentationScreenController.getCurrentFolder();
                let folderId = folder ? folder.id : null;
                let documentOpenedInChat = chatScreenController.projectDocumentDetailsOpen;

                if (documentOpenedInChat && !folder) {
                    folder = chatScreenController.sendedProjectDocuments[documentId].folder;
                    folderId = folder.id;
                }

                const wallLikeCommentAnimation = $("#gif-comment-liked-" + commentId + "-advanced-" + folderId).last();
                const wallLikeCommentButton = $(".mark-comment-liked-advanced[data-comment=" + commentId + "]").last();

                const detailsLikeCommentAnimation = $("#gif-comment-liked-" + commentId);
                const detailsLikeCommentButton = $(".mark-comment-liked[data-comment=" + commentId + "]");
                const detailsLikesComment = $(".comment-view-likes-button[data-comment=" + commentId + "]");

                const likeIconContainer = $(".like-icon-container.is-like[data-comment=" + commentId + "]");
                const notLikeIconContainer = $(".like-icon-container.is-not-like[data-comment=" + commentId + "]");

                const currentLikesNumber = parseInt(detailsLikesComment.text());

                if (data['like']) {

                    if (commentId === document.last_comment.comment_id) {
                        document.last_comment.like_user_world_ids.push(String(user.user_world_id));
                    }

                    // Like desde la vista detalles
                    if (documentationScreenController.folderModeView === 'details') {

                        detailsLikeCommentButton.find(".is-not-like").hide();
                        DocumentationUtils.likeAnimation(detailsLikeCommentAnimation, function () {

                            detailsLikeCommentButton.find(".is-like").show();
                            detailsLikeCommentAnimation.html(null);
                            detailsLikesComment.text(sprintf(Translator.trans("TR_X_ME_GUSTA"), currentLikesNumber + 1));

                        });

                        // Like desde la vista muro
                    } else {

                        notLikeIconContainer.hide();
                        DocumentationUtils.likeAnimation(wallLikeCommentAnimation, function () {

                            likeIconContainer.show();
                            wallLikeCommentAnimation.html(null);

                        });

                    }

                } else {

                    if (commentId === document.last_comment.comment_id) {
                        _.remove(document.last_comment.like_user_world_ids, function (userWorldId) {
                            return userWorldId === String(user.user_world_id);
                        });
                    }

                    wallLikeCommentButton.find(".is-like").hide();
                    wallLikeCommentButton.find(".is-not-like").show();
                    detailsLikeCommentButton.find(".is-like").hide();
                    detailsLikeCommentButton.find(".is-not-like").show();
                    detailsLikesComment.text(sprintf(Translator.trans("TR_X_ME_GUSTA"), currentLikesNumber - 1));

                }

            } else {
                // console.log(Translator.trans('TR_SET_LIKE_ERROR'));
                // console.log(data['message']);
            }
        });

        docSocket.on(SocketEvents.SET_FAVORITE_RESPONSE(), function (data) {
            if (data['success']) {
                let icon = $("[id=favourite-icon-" + data['document_id'] + "]");

                let currentFolder = documentationScreenController.getCurrentFolder();
                let folderId = currentFolder ? currentFolder.id : null;
                let documentId = data["document_id"];
                let activeFilters = $('.filterEnabled');
                let searchTerm = $('.documentation-searchbar').val();
                let validSearchTerm = searchTerm && searchTerm.length > 0;
                let documentOpenedInChat = chatScreenController.projectDocumentDetailsOpen;

                if (documentOpenedInChat && !currentFolder) {
                    currentFolder = chatScreenController.sendedProjectDocuments[documentId].folder;
                    folderId = currentFolder.id;
                }

                let document = documentationScreenController.getDocument(documentId);
                document['favourite'] = data['favorite'];

                let hasFavouriteFilter = $(".filterEnabled[data-filter='favourite'][data-status='1']").length;
                let hasNoFavouriteFilter = $(".filterEnabled[data-filter='favourite'][data-status='2']").length;
                let documentationContent = $("body").last();

                const wallFavourites = $(".bf-smart-list[data-document=" + documentId + "] .document-favourites-value");
                const detailsFavourites = $("#document-details-content .document-favourites-value");
                const currentFavouritesNumber = parseInt(wallFavourites.last().length > 0 ? wallFavourites.last().text() : detailsFavourites.text());

                const wallFavouriteButton = $(".mark-favourite-advanced-" + folderId + "[data-document=" + documentId + "]");
                const detailsFavouriteButton = $(".mark-favourite[data-document=" + documentId + "]");
                const listFavouriteButton = $(".slide-action-button[data-document=" + documentId + "][data-action=favourite]");

                const socialDataFavouriteIcon = $(".social-data-favourite-icon-container.is-favourite[data-document=" + documentId + "]");
                const socialDataNotFavouriteIcon = $(".social-data-favourite-icon-container.is-not-favourite[data-document=" + documentId + "]");

                const favouriteIconContainer = $(".favourite-icon-container.is-favourite[data-document=" + documentId + "]");
                const notFavouriteIconContainer = $(".favourite-icon-container.is-not-favourite[data-document=" + documentId + "]");

                const pathActionButton = $(".path-action-button[data-action=favourite]");

                // console.log('click on: is favorite');
                if (window.reactZustandBridge) {
                    window.reactZustandBridge.updateContent(
                        document.folder.id,
                        document.id,
                        {
                            isFavorite: data['favorite'] ?? false,
                            metrics: {
                                favorites: data['favorite'] ? document.total_favourites++ : document.total_favourites--,
                            }
                        }
                    );
                }

                if (data['favorite']) {

                    icon.show();

                    document['total_favourites'] += 1;
                    wallFavourites.text(isNaN(currentFavouritesNumber) ? 1 : currentFavouritesNumber + 1);
                    detailsFavourites.text(isNaN(currentFavouritesNumber) ? 1 : currentFavouritesNumber + 1);

                    notFavouriteIconContainer.hide();
                    favouriteIconContainer.show();
                    socialDataNotFavouriteIcon.hide();
                    socialDataFavouriteIcon.show();
                    pathActionButton.find(".is-not-favourite").hide();
                    pathActionButton.find(".is-favourite").show();

                    if (hasNoFavouriteFilter) {
                        documentationContent.find("li[data-document='" + data['document_id'] + "']").remove();
                        let documentsLength = documentationContent.find("#documentation-documents li").length;

                        $("#folder-items-amount-" + folderId).text(" (" + documentsLength + ")");
                    }
                } else {

                    icon.hide();

                    document['total_favourites'] -= 1;
                    wallFavourites.text(currentFavouritesNumber === 1 ? "--" : currentFavouritesNumber - 1);
                    detailsFavourites.text(currentFavouritesNumber === 1 ? "--" : currentFavouritesNumber - 1);

                    notFavouriteIconContainer.show();
                    favouriteIconContainer.hide();
                    socialDataNotFavouriteIcon.show();
                    socialDataFavouriteIcon.hide();
                    pathActionButton.find(".is-favourite").hide();
                    pathActionButton.find(".is-not-favourite").show();

                    if (hasFavouriteFilter) {
                        documentationContent.find("li[data-document='" + data['document_id'] + "']").remove();
                        let documentsLength = documentationContent.find("#documentation-documents li").length;

                        $("#folder-items-amount-" + folderId).text(" (" + documentsLength + ")");
                    }
                }

                if (!documentOpenedInChat && documentationScreenController.documentationScroll.manageItemsScroll) {
                    var currentScroll = null; //documentationContent.getNiceScroll()[0];
                    var lastScroll = documentationContent.data("scroll");
                    documentationScreenController.documentationScroll.manageItemsScroll(null, currentScroll, lastScroll);
                }

            } else {
                // console.log(Translator.trans('TR_SET_FAVOURITE_ERROR'));
                // console.log(data['message']);
            }
        });

        if (world.can_rate_documentation) {
            docSocket.on(SocketEvents.RATE_DOCUMENT_RESPONSE(), function (data) {
                if (data['success']) {
                    let timeDiff = 0;

                    if (documentationScreenController.elapsedSendingTime) {
                        timeDiff = new Date() - documentationScreenController.elapsedSendingTime;

                        if (timeDiff >= 1000) {
                            timeDiff = 0;
                        } else {
                            timeDiff = 1000 - timeDiff;
                        }
                    }

                    setTimeout(() => {
                        $(".bottomDisplayedSection").hide();
                        $(".ratingMessageText").hide();

                        let documentId = data["document_id"];
                        let activeFilters = $('.filterEnabled');
                        let searchTerm = $('.documentation-searchbar').val();
                        let validSearchTerm = searchTerm && searchTerm.length > 0;
                        let documentOpenedInChat = chatScreenController.projectDocumentDetailsOpen;
                        let document = documentationScreenController.getDocument(documentId);
                        let buttonRatingBorder = $("#rating-selected-border-" + documentId);

                        if (data['user_world_id'] == user.user_world_id) {
                            document['user_rating'] = data['rating'];

                            let smileIconName = "RATE_SMILE_" + data['rating'];
                            let smileIcon = customIcons[smileIconName];

                            let rateGroup = $("#rateInputGroup");
                            rateGroup.addClass("ratingCompleted");
                            rateGroup.find(".smilie" + data['rating']).attr("src", smileIcon).closest(".ratingImg").toggleClass("ratingSelected ratingDisabled");

                            let advancedRateGroup = $("#rate-input-" + documentId);
                            advancedRateGroup.addClass("ratingCompleted");
                            advancedRateGroup.find(".smilie" + data['rating']).attr("src", smileIcon).closest(".ratingImg").toggleClass("ratingSelected ratingDisabled");

                            let pathRateGroup = $("#rateInputGroupPathScroll");
                            pathRateGroup.addClass("ratingCompleted");
                            pathRateGroup.find(".smilie" + data['rating']).attr("src", smileIcon).closest(".ratingImg").toggleClass("ratingSelected ratingDisabled");

                            // Seleccionar el icono que el usuario acaba de clicar en el dialogo de rate. Pantalla documentacion.
                            $(advancedRateGroup).find('span').each(function (i, elem) {
                                let rateFace = $(elem).data('rating');
                                if (data['rating'] === rateFace) {
                                    $(this).addClass("ratingSelected");
                                    $(this).removeClass("ratingDisabled");
                                }
                            });

                            // Seleccionar el icono que el usuario acaba de clicar en el dialogo de rate. Documentacion avanzada.
                            $('#rateInputGroup span').each(function (i, elem) {
                                let rateFace = $(elem).data('rating');
                                if (data['rating'] === rateFace) {
                                    $(this).addClass("ratingSelected");
                                    $(this).removeClass("ratingDisabled");
                                }
                            })

                            // Seleccionar el icono que el usuario acaba de clicar en el dialogo de rate. Path Scroll.
                            $('#rateInputGroupPathScroll > .ratingImg').each(function (i, elem) {
                                let rateFace = $(elem).data('rating');
                                if (data['rating'] === rateFace) {
                                    $(this).addClass("ratingSelected");
                                    $(this).removeClass("ratingDisabled");
                                }
                            })

                        }

                        let ratingSelected = DocumentationUtils.getSelectedRating(data);
                        let smileIconName = "RATE_SMILE_" + ratingSelected;
                        let smileIcon = customIcons[smileIconName];

                        $(".info-bar-text .rating-average-value").not('.advanced-rating-average').text(data['rating_average']);

                        document['rating_average'] = data['rating_average'];
                        document['rating_amount'] = data['rating_amount'];
                    }, timeDiff);
                } else {
                    // console.log(Translator.trans('TR_DOCUMENT_RATING_ERROR'));
                    // console.log(data['message']);
                }
            });
        }

        docSocket.on(SocketEvents.REMOVE_NEW_RESPONSE(), function (data) {
            if (data['success']) {
                let currentFolder = documentationScreenController.getCurrentFolder();

                if (!currentFolder) {
                    currentFolder = documentationScreenController.getParentFolder(data.document_id, documentationScreenController.documentation);
                }

                let folderId = currentFolder ? currentFolder.id : null;
                let documentId = data["document_id"];
                let activeFilters = $('.filterEnabled');
                let searchTerm = $('.documentation-searchbar').val();
                let validSearchTerm = searchTerm && searchTerm.length > 0;
                let documentOpenedInChat = chatScreenController.projectDocumentDetailsOpen;

                if (documentOpenedInChat && !currentFolder) {
                    currentFolder = chatScreenController.sendedProjectDocuments[documentId].folder;
                    folderId = currentFolder.id;
                }

                let icon = $(".bf-smart-list[data-document=" + documentId + "] .new-icon");
                icon.hide();

                let hasNewFilter = $(".filterEnabled[data-filter='new']").length;

                if (hasNewFilter) {
                    let documentationContent = $("body").last();
                    documentationContent.last().find("a[data-id='" + documentId + "']").closest("li").remove();

                    let documentsLength = documentationContent.find("#documentation-documents li").length;
                    $("#folder-items-amount-" + folderId).text(" (" + documentsLength + ")");

                    let currentScroll = null; //documentationContent.getNiceScroll()[0];
                    let lastScroll = documentationContent.data("scroll");

                    documentationScreenController.documentationScroll.manageItemsScroll(null, currentScroll, lastScroll);
                }
            } else {
                // console.log(Translator.trans('TR_READ_DOCUMENT_ERROR'));
                // console.log(data['message']);
            }
        });

        if (world.can_comment_documentation) {
            docSocket.on(SocketEvents.ADD_COMMENT_RESPONSE(), function (data) {
                if (data['success']) {
                    let timeDiff = new Date() - documentationScreenController.elapsedSendingTime;

                    if (timeDiff >= 1000) {
                        timeDiff = 0;
                    } else {
                        timeDiff = 1000 - timeDiff;
                    }

                    $(".not-info").remove();

                    setTimeout(function () {
                        let comment = data['comment'];
                        let documentId = data["document_id"];
                        let activeFilters = $('.filterEnabled');
                        let searchTerm = $('.documentation-searchbar').val();
                        let validSearchTerm = searchTerm && searchTerm.length > 0;
                        let documentOpenedInChat = chatScreenController.projectDocumentDetailsOpen;


                        documentationScreenController.documentationComment.drawComment(data);

                        $(".sendingMessageText").hide();
                        $('.document-info-bar .comments-amount').text(data['total_comments']);
                        $("#documentComment-" + documentId + "-details").trigger("click");

                        let document = documentationScreenController.getDocument(documentId);

                        document['total_comments'] = data['total_comments'] || 0;
                        document.last_comment = data;
                        document.last_comment.author_data = user;

                    }, timeDiff);
                } else {
                    // console.log(Translator.trans('TR_READ_DOCUMENT_ERROR'));
                    // console.log(data['message']);
                }
            });

            docSocket.on(SocketEvents.EDIT_COMMENT_RESPONSE(), function (data) {

                if (data['success']) {

                    const commentId = data['comment_id'];
                    documentationScreenController.documentationComment.editComment(commentId, data);

                } else {
                    console.trace(Translator.trans('TR_READ_DOCUMENT_ERROR'));
                    console.trace(data['message']);
                }

            });

            docSocket.on(SocketEvents.REMOVE_COMMENT_RESPONSE(), function (data) {

                if (data['success']) {

                    let comment = data['comment'];
                    let documentId = data["document_id"];
                    let activeFilters = $('.filterEnabled');
                    let searchTerm = $('.documentation-searchbar').val();
                    let documentOpenedInChat = chatScreenController.projectDocumentDetailsOpen;

                    let document = documentationScreenController.getDocument(documentId);
                    documentationScreenController.documentationComment.deleteComment(data.removed_comments);

                    const wallComments = $(".bf-smart-list[data-document=" + documentId + "] .document-comments-value");
                    const detailsComments = $("#document-details-content .document-comments-value");

                    document['total_comments'] = data['total_comments'] || 0;
                    wallComments.text(data['total_comments']);
                    detailsComments.text(data['total_comments']);

                } else {
                    // console.log(Translator.trans('TR_READ_DOCUMENT_ERROR'));
                    // console.log(data['message']);
                }

            });

        }


    }

}
